import { render } from "./Main.vue?vue&type=template&id=9d96b740"
const script = {}
script.render = render

export default script